import { Swap } from '@drift-labs/icons';
import IconButton from 'src/components/primitives/IconButton/IconButton';

interface Props {
	label: string;
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Renders the passed label with a `Swap` icon button to its right.
 */
export default function ToggleHeaderCell({ label, onClick }: Props) {
	return (
		<span className="flex items-center gap-x-xs">
			{label}
			<IconButton size="sm" variant="tertiary" onClick={onClick} icon={Swap} />
		</span>
	);
}
